import { initialPathConfig } from "../../pages/deliveryIssues/initialPathConfig";
import { useAppStorage } from "./useAppStorage";

interface PathUtilsProps {
  namePath?: string;
  componentName?: string;
};

const methods = {
  checkLandingURL: () => {
    try {
      if (window && typeof window !== 'undefined') {
        const url = new URL(window.location.href);
        return url.pathname;
      }
      return '';
    } catch (e) {
      return '';
    }
  },
  getPathConfiguration: ({ namePath }: PathUtilsProps) => {
    const arrayPathConfiguration = initialPathConfig;
    const configuration = arrayPathConfiguration.find((step) => step.namePath === namePath);
    return JSON.parse(JSON.stringify(configuration));
  },
  getPathConfigFromStorage: ({ componentName }: PathUtilsProps) => {
    const config = useAppStorage('getStorageItem', `pathConfiguration${componentName}`);
    if (!config) {
      return null;
    }
    return { config: JSON.parse(config) };
  },
};

export function usePathUtils(method: keyof typeof methods, args?: PathUtilsProps) {
  const urlMethod = methods[method];
  return urlMethod(args);
};
